import React from "react";
import { useDispatch } from "react-redux";
import { useGetPortfolios } from "api/ux/src";
import { filterTagLabels, prepareTagRows } from "components/tags/helpers";
import { useFetchTagsQuery } from "components/tags/tagsApi";
import { TagEntityType } from "components/tags/types";
import { InsGrid } from "components/widgets";
import { CustomColumnType } from "components/widgets/grid/grid-column-types";
import { language } from "language/default";
import { setSelectedRowsState } from "store/grids";
const mLanguage = language.en.administration.dataAdministration.exportData.portfolios;
export const InsPortfoliosDataExportGrid = (props) => {
    const [rows, querystate] = useGetPortfolios();
    const dispatch = useDispatch();
    const cols = [
        { field: "Id", hide: true },
        { checkboxSelection: true,
            field: "Name",
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerName: mLanguage.name,
            sort: "asc",
            type: [CustomColumnType.InsLinkColumn] },
        { field: "Currency", headerName: mLanguage.currency, type: CustomColumnType.InsTextSetColumn },
        { field: "AladdinTicker", headerName: mLanguage.aladdinTicker, type: CustomColumnType.InsTextSetColumn },
        {
            field: "tags",
            filter: "agSetColumnFilter",
            filterValueGetter: filterTagLabels,
            headerName: "Tags",
            type: [CustomColumnType.InsTagsColumn]
        }
    ];
    const { data: dataTags } = useFetchTagsQuery({ entityType: TagEntityType.PORTFOLIO });
    let rowsForGrid = rows.map((row) => ({
        AladdinTicker: row.ticker,
        Currency: row.currency,
        Id: row.id,
        Name: row.name
    }));
    rowsForGrid = prepareTagRows(rowsForGrid, dataTags);
    return React.createElement(React.Fragment, null,
        React.createElement(InsGrid, { stateId: props.stateId, selectionMode: "multiple", rowSelectedHandler: ((e) => {
                dispatch(setSelectedRowsState({
                    id: props.stateId,
                    selectedRows: e.api.getSelectedRows()
                        .map((row) => `${row.Id}`)
                }));
            }), widgetId: props.stateId, columnDefs: cols, rowData: rowsForGrid, queryState: querystate }));
};
